(function () {
  'use strict';

  angular.module('app').service('InvoiceModalService', InvoiceModalService);

  InvoiceModalService.$inject = ['ModalService'];

  function InvoiceModalService(ModalService) {
    var preventModalClose = {
      backdrop: 'static',
      keyboard: false,
    };

    var service = {
      openAddBookingToInvoice: openAddBookingToInvoice,
      openInvoiceChangeStatus: openInvoiceChangeStatus,
      openSendInvoiceToClient: openSendInvoiceToClient,
    };

    return service;

    ////////////////////////

    function openAddBookingToInvoice(invoice, client, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/invoices/modals/invoice-select-booking-modal.html',
        controller: InvoiceSelectBookingModalCtrl,
        controllerAs: 'vm',
        inputs: {
          invoice: invoice,
          client: client,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });

      InvoiceSelectBookingModalCtrl.$inject = ['$element', 'invoice', 'client', 'successCallback'];
    }

    function InvoiceSelectBookingModalCtrl($element, invoice, client, successCallback) {
      var vm = this;

      vm.invoice = invoice;
      vm.client = client;

      // Methods
      vm.onBookingSelected = onBookingSelected;

      function onBookingSelected(booking) {
        $element.modal('hide');
        successCallback(booking);
      }
    }

    // Modal invoice change status
    function openInvoiceChangeStatus(invoice, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/invoices/modals/invoice-change-status-modal.html',
        controller: InvoiceChangeStatusCtrl,
        controllerAs: 'vm',
        inputs: {
          invoice: invoice,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });
    }

    function InvoiceChangeStatusCtrl($element, invoice, successCallback) {
      var vm = this;

      vm.invoice = invoice;
      vm.colorMode = 'default';

      vm.changeHeaderColor = changeHeaderColor;
      vm.onInvoiceStatusChanged = onInvoiceStatusChanged;

      function onInvoiceStatusChanged() {
        $element.modal('hide');
        successCallback();
      }

      function changeHeaderColor(option) {
        vm.colorMode = option;
      }
    }

    // Modal invoice send email
    function openSendInvoiceToClient(clientEmail, successCallback) {
      ModalService.showModal({
        templateUrl: './app/ajs/invoices/modals/send-invoice-to-client-modal.html',
        controller: InvoiceSendEmailCtrl,
        controllerAs: 'vm',
        inputs: {
          clientEmail: clientEmail,
          successCallback: successCallback,
        },
      }).then(function (modal) {
        modal.element.modal(preventModalClose);
      });
    }

    function InvoiceSendEmailCtrl($element, clientEmail, successCallback) {
      let vm = this;

      vm.clientEmail = clientEmail;

      vm.sendInvoice = function (isFormValid) {
        if (!isFormValid) return;

        vm.sendingForm = true;

        $element.modal('hide');
        successCallback(vm.clientEmail);
      };
    }
  }
})();
